<template>
  <div
    v-if="embedded"
    class="choose-icon-input choose-icon-input--embedded"
    :class="{ 'choose-icon-input--disabled': disabled }"
  >
    <ApiIcon
      v-if="icon"
      :type="icon.type"
      :name="icon.name"
      :iconStyle="icon.style"
    ></ApiIcon>
    <ion-label v-if="iconName" class="choose-icon-input__value">{{
      iconName
    }}</ion-label>
    <ion-label v-else class="choose-icon-input__value choose-icon-input__value--empty">
      No icon
    </ion-label>
    <ion-button
      @click="chooseIconModalIsOpen = true"
      :disabled="disabled"
      size="small"
    >Change</ion-button>
  </div>
  <ion-item v-else>
    <ion-label>Icon</ion-label>
    <ApiIcon
      v-if="icon"
      :type="icon.type"
      :name="icon.name"
      :iconStyle="icon.style"
    ></ApiIcon>
    <ion-label v-if="iconName">{{ iconName }}</ion-label>
    <ion-button @click="chooseIconModalIsOpen = true" :disabled="disabled"
      >Change</ion-button
    >
  </ion-item>
  <ion-modal
    :is-open="chooseIconModalIsOpen"
      :can-dismiss="canDismissExceptGesture"
    :backdrop-dismiss="true"
    :presenting-element="presentingElement"
  >
    <ChooseIconModal v-model="value" @save="chooseIconModalIsOpen = false" />
  </ion-modal>
</template>
<script setup lang="ts">
import { canDismissExceptGesture } from "@/helper/modalDismiss";
import ApiIcon from "@/components/ApiIcon.vue";
import { IonItem, IonLabel, IonButton, IonModal } from "@ionic/vue";
import ChooseIconModal from "@/components/modals/ChooseIconModal.vue";
// noinspection ES6UnusedImports
import { computed, defineComponent, ref, watch } from "vue";
// noinspection ES6UnusedImports
import type { FontAwesomeIcon } from "@/models/api";
import { iconObjectToIconString } from "@/helper/icons";
import { undefinedToNull } from "@/helper/undefinedToNull";
import { usePresentingElement } from "@/composables/usePresentingElement";

defineComponent({
  name: "ChooseIconInput",
});

const props = defineProps<{
  modelValue: FontAwesomeIcon | null;
  disabled?: boolean;
  embedded?: boolean;
}>();

const emit = defineEmits<{
  (
    e: "update:modelValue",
    value:
      | FontAwesomeIcon
      | null
  ): void;
}>();

const { presentingElement } = usePresentingElement();
const chooseIconModalIsOpen = ref(false);
const value = ref<FontAwesomeIcon | null>(
  undefinedToNull(props.modelValue)
);
watch(
  () => props.modelValue,
  (newVal) => {
    value.value = undefinedToNull(newVal);
  }
);
watch(value, (newVal, oldVal) => {
  console.log("choosenIcon:", newVal);
  if (newVal !== oldVal) {
    emit("update:modelValue", newVal);
  }
});
const icon = computed<null | FontAwesomeIcon>(() =>
  value.value ? value.value : null
);
const iconName = computed<null | string>(() =>
  icon.value ? iconObjectToIconString(icon.value) : null
);
</script>
<style scoped lang="scss">
.choose-icon-input {
  align-items: center;
  display: flex;
  gap: 0.5em;
  min-width: 0;
  width: 100%;
}

.choose-icon-input--disabled {
  opacity: 0.55;
}

.choose-icon-input__value {
  flex: 1 1 auto;
  min-width: 0;
  overflow-wrap: anywhere;
}

.choose-icon-input__value--empty {
  color: var(--ion-color-medium);
}

@media (max-width: 430px) {
  .choose-icon-input--embedded {
    align-items: stretch;
    flex-wrap: wrap;
  }

  .choose-icon-input--embedded .choose-icon-input__value {
    flex-basis: calc(100% - 2.5em);
  }

  .choose-icon-input--embedded ion-button {
    margin-left: auto;
  }
}
</style>
